<template>
  <div class="md-layout items-center">
    <div
      class="md-layout-item md-size-20 min-w-[200px] md-xsmall-size-100 px-0"
    >
      <img
        class="avatar w-[150px] h-[150px] rounded-full"
        :src="studentInfo.avatar || '/img/avt_placeholder.jpg'"
      />
    </div>
    <div class="md-layout-item md-size-65 md-xsmall-size-100 px-0">
      <p class="font-medium">
        {{ $t("common.full_name") }}: {{ studentInfo.full_name }}
      </p>
      <p class="font-normal">
        {{ $t("common.student_code") }}: {{ studentInfo.student_code }}
      </p>
      <slot name="extra-info"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "studentInfo"],
  methods: {}
};
</script>
